import { useEffect, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrentCompany } from '../../hooks/useCurrentCompany';

/**
 * Route component that redirects students to student-landing page.
 * If the user has multiple company affiliations, redirects to the company
 * selector instead — they may be an owner/admin at another company.
 */
export function StudentRedirectRoute({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const { role, allCompanies, isLoading } = useCurrentCompany();

  useEffect(() => {
    if (isLoading) return;

    if (role && !['owner', 'admin'].includes(role)) {
      // Multi-company users may be owner/admin at another company — let them pick
      if (allCompanies.length > 1) {
        navigate('/company-selector', { replace: true });
      } else {
        navigate('/student-landing', { replace: true });
      }
    }
  }, [role, allCompanies, isLoading, navigate]);

  // Don't render children while user is confirmed non-owner/admin
  if (!isLoading && role && !['owner', 'admin'].includes(role)) {
    return null;
  }

  return children;
}
